export const rabbitSignSignerStatuses = Object.freeze({
  notified: "NOTIFIED",
  signed: "SIGNED"
});